import MovieListArrowLeft from './MovieListArrowLeft';

export default MovieListArrowLeft;
